import { type GetItemPropsOptions } from 'downshift'
import { Text } from 'pcln-design-system'
import type { LOCATION_SEARCH_TYPE } from '@/types'
import SearchItem from './SearchItem'

type RenderRecentSearchesType = {
  getItemProps: (
    options: GetItemPropsOptions<LOCATION_SEARCH_TYPE>
  ) => Record<string, unknown>
  highlightedIndex: number | null
  recentSearches: LOCATION_SEARCH_TYPE[]
  recentOrRecommendationTitle: string
  useNewTypeaheadIcons?: boolean
}

function RenderRecentSearches({
  getItemProps,
  highlightedIndex,
  recentSearches,
  recentOrRecommendationTitle,
  useNewTypeaheadIcons = false
}: Readonly<RenderRecentSearchesType>) {
  return (
    <>
      <Text fontSize={0} p={2} fontWeight="bold">
        {recentOrRecommendationTitle}
      </Text>
      {recentSearches.map((item, index) => {
        return (
          <SearchItem
            key={item.id}
            isItemSelected={index === highlightedIndex}
            index={index}
            item={{ ...item, skipFeedbackCall: true }}
            getItemProps={getItemProps}
            useNewTypeaheadIcons={useNewTypeaheadIcons}
          />
        )
      })}
    </>
  )
}

export default RenderRecentSearches
